import { useEffect, useState } from 'react';
import { fetchKalenteriList } from '@/services/kalenteriService';

export function useCalendars() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Jos komponentti unmounttaa haun aikana
    let ignore = false;

    (async () => {
      try {
        const res = await fetchKalenteriList();
        if (!ignore) setData(res);
      }
      catch (e) {
        if (!ignore) setError(e);
      }
      finally {
        if (!ignore) setLoading(false);
      }
    })();

    return () => {
      ignore = true;
    };
  }, []);

  return { data, loading, error };
};
